import api from '@/api/api-endpoints'
import { createAsyncMutation, doAsyncPost } from '@/api/async-util'
const types = {
    SEND_CONTACT_EMAIL: createAsyncMutation('SEND_CONTACT_EMAIL'),
    SEND_TICKET_EMAIL: createAsyncMutation('SEND_TICKET_EMAIL'),
    SUBMIT_ORDER_CONTACT_TO_BENCHMARK: createAsyncMutation('SUBMIT_ORDER_CONTACT_TO_BENCHMARK'),
    SUBMIT_NEWS_CONTACT_TO_BENCHMARK: createAsyncMutation('SUBMIT_NEWS_CONTACT_TO_BENCHMARK'),
    SUBMIT_DOWNLOAD_CONTACT_TO_BENCHMARK: createAsyncMutation('SUBMIT_DOWNLOAD_CONTACT_TO_BENCHMARK'),
    VERIFY_RECAPTCHA_TOKEN: createAsyncMutation('VERIFY_RECAPTCHA_TOKEN'),
}

const email = {
    state: {},
    mutations: {},
    actions: {
        // GET


        // POST
        sendContactEmail(store, payload) {
            let url = api.email + 'Contact'
            return doAsyncPost(store, { url, mutationTypes: types.SEND_CONTACT_EMAIL, payload })
        },

        sendTicketEmail(store, payload) {
            let url = api.email + 'HelpTicket'
            return doAsyncPost(store, { url, mutationTypes: types.SEND_TICKET_EMAIL, payload })
        },

        submitOrderContactToBenchmark(store, payload) {
            let url = api.email + 'SubmitOrderContactToBenchmark'
            if (payload) {
                url += '?email=' + payload.email
                url += '&firstName=' + payload.firstName
                url += '&lastName=' + payload.lastName
                url += '&orderID=' + payload.orderID
            }
            return doAsyncPost(store, { url, mutationTypes: types.SUBMIT_ORDER_CONTACT_TO_BENCHMARK })
        },

        submitNewsContactToBenchmark(store, payload) {
            let url = api.email + 'SubmitNewsContactToBenchmark'
            if (payload) {
                url += '?email=' + payload.email
                url += '&firstName=' + payload.firstName
                url += '&lastName=' + payload.lastName
            }
            return doAsyncPost(store, { url, mutationTypes: types.SUBMIT_NEWS_CONTACT_TO_BENCHMARK })
        },

        submitDownloadContactToBenchmark(store, payload) {
            let url = api.email + 'SubmitDownloadContactToBenchmark'
            if (payload) {
                url += '?email=' + payload.email
                url += '&firstName=' + payload.firstName
                url += '&lastName=' + payload.lastName
                url += '&prodCatID=' + payload.prodCatID
            }
            return doAsyncPost(store, { url, mutationTypes: types.SUBMIT_DOWNLOAD_CONTACT_TO_BENCHMARK })
        },

        async verifyRecaptchaToken(store, token) {
            let url = api.email + 'VerifyRecaptchaToken'
            let payload = { token: token }
            return await doAsyncPost(store, { url, mutationTypes: types.VERIFY_RECAPTCHA_TOKEN, payload })
        }

        // PUT
        // DELETE

    },
    getters: {},
    types: types
}

export default email
